import React, { useEffect } from 'react'
import allowedFonts from '~/Classes/fonts';
import ExampleTemplate1 from './exampleTemplate1';
import ExampleTemplate2 from './exampleTemplate2';
import ExampleTemplate3 from './exampleTemplate3';


const TemplateExamples = ({ colours, logo, headingFont, bodyFont }) => {

    // Find our google fonts
    const gHeadingFont = allowedFonts.find(f => f.value.toLowerCase() === headingFont.toLowerCase());
    const gBodyFont = allowedFonts.find(f => f.value.toLowerCase() === bodyFont.toLowerCase());

    // Collect unique Google fonts to include
    const googleFonts = [];
    if (gHeadingFont && gHeadingFont.src === "google") {
        googleFonts.push(gHeadingFont.label);
    }
    if (
        gBodyFont &&
        gBodyFont.src === "google" &&
        (!gHeadingFont || gBodyFont.label !== gHeadingFont.label)
    ) {
        googleFonts.push(gBodyFont.label);
    }

    useEffect(() => {
        if (googleFonts.length === 0) return;

        const fontFamilies = googleFonts.map(f => f.replace(/ /g, '+')).join('|');
        const href = `https://fonts.googleapis.com/css?family=${fontFamilies}:400,700,400italic,700italic`;

        // Check if link already exists
        let link = document.querySelector(`link[data-google-fonts="${fontFamilies}"]`);
        if (!link) {
            link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = href;
            link.setAttribute('data-google-fonts', fontFamilies);
            document.head.appendChild(link);
        }

        // Optional: Cleanup function to remove the link when component unmounts or fonts change
        return () => {
            if (link && link.parentNode) {
                link.parentNode.removeChild(link);
            }
        };
    }, [googleFonts.join('|')]);

    const primaryColour = colours[0];
    const textColour = colours[1];
    const backgroundColour = colours[2];

    return (
        <div style={{ width: "100%" }}>
            <div style={{ display: "flex", gap: "16px" }}>
                <ExampleTemplate1
                    primaryColour={primaryColour}
                    backgroundColour={backgroundColour}
                    textColour={textColour}
                    headingFont={headingFont}
                    bodyFont={bodyFont}
                    logo={logo}
                />
                <ExampleTemplate2
                    primaryColour={primaryColour}
                    backgroundColour={backgroundColour}
                    textColour={textColour}
                    headingFont={headingFont}
                    bodyFont={bodyFont}
                    logo={logo}
                />
                <ExampleTemplate3
                    primaryColour={primaryColour}
                    backgroundColour={backgroundColour}
                    textColour={textColour}
                    headingFont={headingFont}
                    bodyFont={bodyFont}
                    logo={logo}
                />
            </div>
        </div>
    )
}

export default TemplateExamples;